var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"atom-title"},[_c('h2',{style:(_vm.color ? { color: _vm.color } : {}),domProps:{"innerHTML":_vm._s(_vm.title)}}),_vm._v(" "),_c('h3',{style:(_vm.color2 ? { color: _vm.color2 } : {}),domProps:{"innerHTML":_vm._s(_vm.subtitle)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }